import { useTranslation } from "react-i18next";
import { ListChecks } from "lucide-react";
import { BoqSectionCard } from "./BoqSectionCard";
import type { BoqSectionAnalysis } from "./types";

export const BoqSectionsSection = ({
  sections,
  totalPositions,
  onNavigate,
}: {
  sections?: BoqSectionAnalysis[];
  totalPositions?: number;
  onNavigate: (file: string, page: number) => void;
}) => {
  const { t } = useTranslation();

  if (!sections || sections.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="px-5 py-3.5 border-b border-gray-100 flex items-center gap-2.5">
        <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center">
          <ListChecks size={16} className="text-emerald-600" />
        </div>
        <h3 className="text-sm font-semibold text-gray-900">
          {t("smartSurveyor.researchReport.boqSections")}
        </h3>
        {totalPositions !== undefined && totalPositions > 0 && (
          <span className="text-xs text-gray-400 ml-auto">
            {totalPositions} {t("smartSurveyor.researchReport.positions")}
          </span>
        )}
      </div>
      <div className="p-4 space-y-2">
        {sections.map((s) => (
          <BoqSectionCard
            key={`${s.section_number}-${s.section_title}`}
            section={s}
            onNavigate={onNavigate}
          />
        ))}
      </div>
    </div>
  );
};
